import React from 'react'
import { MissaoWrapper } from '../style'
import { Col, Row } from 'reactstrap'

const Missao = () => {
  return (
    <MissaoWrapper id="missao-visao-valores">
      <div className="container d-flex flex-column">
        <h2>Missão, Visão e valores</h2>
        <Row>
          <Col md={6}>
            <h3>Missão:</h3>
            <p>
              Proporcionar soluções financeiras confiáveis e acessíveis,
              colocando sempre o cliente no centro de nossas operações, com base
              em valores de ética e integridade.
            </p>
          </Col>
          <Col md={6}>
            <h3>Visão:</h3>
            <p>
              Ser reconhecido como o principal parceiro financeiro dos nossos
              clientes, oferecendo serviços de excelência e contribuindo para o
              crescimento e desenvolvimento da comunidade que servimos.
            </p>
          </Col>
        </Row>
        <h3>Valores:</h3>
        <div>
          <p>
            <b>Ética e Integridade: </b>
            Nossa cultura organizacional é fundamentada em princípios
            inegociáveis. Valorizamos a ética como pilar central,
            comprometendo-nos sempre com a integridade, sem concessões ou
            atalhos. Além disso, nossa liderança é exercida de maneira
            transparente e responsável, refletindo nosso compromisso total com a
            sociedade.
          </p>
        </div>
        <div>
          <p>
            <b>Cliente no Centro: </b>
            Colocamos as necessidades e interesses dos nossos clientes como
            prioridade máxima, buscando sempre superar suas expectativas e
            garantir sua satisfação.
          </p>
        </div>
        <div>
          <p>
            <b>Meritocracia: </b>
            Reconhecemos e recompensamos o desempenho e o mérito individual,
            promovendo uma cultura de igualdade de oportunidades e crescimento
            profissional com base no mérito.
          </p>
        </div>
        <div>
          <p>
            <b>Excelência: </b>
            Buscamos constantemente a excelência em tudo o que fazemos, desde a
            prestação de serviços até a inovação e melhoria contínua, visando
            alcançar os mais altos
          </p>
        </div>
      </div>
    </MissaoWrapper>
  )
}

export default Missao
